const encoder = new TextEncoder();

const textEncoder = (text) => {
    const data = encoder.encode(text);
    return btoa(String.fromCharCode(...data));
}

export default textEncoder;
